import { useEffect, useState } from "react";

const SRC = (fmt) => ({
  src: `/demo/haulguard-demo-${fmt}.mp4`,
  poster: `/demo/haulguard-demo-${fmt}.jpg`,
  captions: `/demo/haulguard-demo-${fmt}.vtt`,
});

export default function DemoVideo() {
  const query = "(max-width: 767px)";
  const [tall, setTall] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const on = (e) => setTall(e.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, []);
  const v = SRC(tall ? "vertical" : "wide");
  return <section id="demo" className="py-16 lg:py-24 bg-primary text-primary-foreground scroll-mt-4" data-testid="demo-section">
    <div className="max-w-6xl mx-auto px-4 lg:px-6">
      <div className="eyebrow text-accent mb-3">See it in 60 seconds</div>
      <h2 className="font-display font-black text-3xl lg:text-5xl tracking-tighter mb-8">From VIN scan to signed handoff.</h2>
      <div className={`mx-auto border-4 border-accent/60 bg-black ${tall ? "max-w-sm" : "max-w-5xl"}`}>
        <video key={v.src} controls playsInline preload="metadata" poster={v.poster}
               className={`w-full block ${tall ? "aspect-[9/16]" : "aspect-video"}`} data-testid="demo-video">
          <source src={v.src} type="video/mp4"/>
          <track kind="captions" src={v.captions} srcLang="en" label="English"/>
        </video>
      </div>
    </div>
  </section>;
}
